<template>
  <v-content>
    <v-layout class="mb-2 mx-3 primary--text" row wrap hidden-md-and-down>
      <v-flex xs4  md2  lg1 order-xs3 order-md1 order-lg1 class="text-xs-left text-lg-center">{{ $t("validity")|upper}}</v-flex>
      <v-flex xs4  md1  lg1 order-xs4 order-md2 order-lg2 class="text-xs-left text-lg-center">{{ $t("compliance")|upper}}</v-flex>
      <v-flex xs6  md3  lg1 order-xs1 order-md3 order-lg3 class="text-xs-left">{{ $t("id")|upper}}</v-flex>
      <v-flex xs6  md3  lg3 order-xs2 order-md4 order-lg4 class="text-xs-left">{{ $t("name")|upper}}</v-flex>
      <v-flex xs12 md12 lg5 order-xs6 order-md6 order-lg5 class="text-xs-left">{{ $t("report_reason")|upper}}</v-flex>
      <v-flex xs4  md3  lg1 order-xs5 order-md5 order-lg6 class="text-xs-right">{{ $t("reported_by")|upper}}</v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 v-for="(guest, index) in guests" :key="guest.id">
        <v-card flat @click.capture="showDetailDialog(index)" style="cursor: pointer">
          <v-card-text>
            <v-layout class="primary--text" row wrap fill-height align-center>
              <!-- V A L I D I T A -->
              <v-flex xs4  md2  lg1 order-xs3 order-md1 order-lg1 class="text-xs-left text-md-center">
                <v-layout row>
                  <v-btn icon @click.stop="confirmVote(guest, 'positive')"
                    :class="guest.positive > 0 ? 'green--text text--lighten-1' : 'grey--text text-lighten-2'">
                    <v-icon small>thumb_up</v-icon>
                    <span class="pl-1">{{guest.positive}}</span>
                  </v-btn>
                  <v-btn icon @click.stop="confirmVote(guest, 'negative')"
                    :class="guest.negative > 0 ? 'red--text text--lighten-1' : 'grey--text text-lighten-2'">
                    <v-icon small>thumb_down</v-icon>
                    <span class="pl-1">{{guest.negative}}</span>
                  </v-btn>
                </v-layout>
              </v-flex>

              <!-- S H O D A -->
              <v-flex xs4  md1  lg1 order-xs4 order-md2 order-lg2 class="text-xs-left text-md-center">
                <v-chip class="red white--text">{{guest.validity}}%</v-chip>
              </v-flex>

              <!-- D O C U M E N T   I D -->
              <v-flex xs6  md3  lg1 order-xs1 order-md3 order-lg3 class="text-xs-left">
                <v-layout row hidden-md-and-down>
                  {{guest.document_id}}
                </v-layout>
                <v-layout row hidden-lg-and-up>
                  <span>{{ $t("id")|upper }}:</span>&nbsp;{{guest.document_id}}
                </v-layout>
              </v-flex>

              <!-- N A M E -->
              <v-flex xs6  md3  lg3 order-xs2 order-md4 order-lg4 class="text-xs-left">
                <v-layout row hidden-md-and-down>
                  <strong>{{guest.last_name + ' ' + guest.first_name}}</strong>
                </v-layout>
                <v-layout row hidden-lg-and-up>
                  <span>{{ $t("name") }}: </span>&nbsp;<strong>{{guest.last_name + ' ' + guest.first_name}}</strong>
                </v-layout>
              </v-flex>

              <!-- N O T E -->
              <v-flex xs12 md12 lg5 order-xs6 order-md6 order-lg5 class="text-xs-left">
                <TagReasonsList :tags="guest.tags"></TagReasonsList>
                <!-- <v-tooltip top v-for="tag in guest.tags" :key="tag" class="mr-1">
                  <img slot="activator" width="32px" class="white--text pa-1" :src="getTagIconUrl(tag)" :alt="getTagIconText(tag)">
                  <span>{{getTagName(tag)}}</span>
                </v-tooltip> -->
                <p class="mr-2 mb-0 truncate">{{guest.note}}</p>
              </v-flex>

              <!-- N A H L A S I L -->
              <v-flex xs4  md3  lg1 order-xs5 order-md5 order-lg6 class="text-xs-right" align-center>
                <v-layout row fill-height align-center>
                  <v-flex xs11>
                    {{guest.created_at|date(true)}} <img :src="getCountryFlagUrl(guest.hotel_country)" alt="guest.hotel_country" width="16px">
                    <br/>
                    <div class="truncate">
                      <!--<a :href="getHotelUrl(guest)" target="_blank">{{guest.hotel}}</a>-->
                      <v-tooltip top>
                        <span slot="activator">{{ guest.hotel_name }}</span>
                        <span>{{ guest.hotel_name }}</span>
                      </v-tooltip>
                    </div>
                  </v-flex>
                  <v-flex xs1>
                    <v-menu open-on-hover>
                      <v-btn dark fab small color="blue-grey" slot="activator">
                        <v-icon>more_vert</v-icon>
                      </v-btn>
                      <v-list>
                        <v-list-tile @click="showDetailDialog(index)">
                          <v-list-tile-title>
                            <v-icon>info</v-icon>
                            {{ $t("guest_detail") }}
                          </v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click="editGuest(index)" v-if="guest.creator_id === user.id">
                          <v-list-tile-title>
                            <v-icon>edit</v-icon>
                            {{ $t("guest_edit") }}
                          </v-list-tile-title>
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <!-- <v-fab-transition>
              <v-btn
                dark
                color="blue-grey"
                fab
                small
                absolute
                bottom
                right
                @click="editGuest(index)"
              >
                <v-icon>edit</v-icon>
              </v-btn>
            </v-fab-transition> -->
          </v-card-text>
        </v-card>
        <v-divider v-if="index < guests.length - 1"></v-divider>
      </v-flex>
    </v-layout>
    <guest-dialog :showDialog="showDialog" @closeDialog="closeDialog" :guest="editedGuest"></guest-dialog>
    <GuestDetail :showDialog="showGuestDetailDialog" @closeDialog="closeDetailDialog" :guest="editedGuest"></GuestDetail>
  </v-content>
</template>

<script>
  import * as utils from '../../utils'
  import GuestDetail from './GuestDetail'
  import TagReasonsList from '../components/TagReasonsList'

  export default {
    name: 'guests-list',
    props: {
      guests: {
        required: true
      },
      editable: {
        type: Boolean,
        default: false
      }
    },
    components: {
      GuestDetail, TagReasonsList
    },

    data () {
      return {
        showDialog: false,
        showGuestDetailDialog: false,
        editedGuest: null,
        otherMouseClick: false
      }
    },
    computed: {
      user () {
        return this.$store.getters.user
      }
    },

    methods: {
      editGuest (index) {
        this.editedIndex = index
        this.editedGuest = this.guests[index]
        this.showDialog = true
      },
      closeDialog (guest) {
        if (guest === 'deleted') {
          this.guest.splice(this.editedIndex, 1)
        } else if (guest !== null) {
          this.guests[this.editedIndex] = Object.assign(this.guests[this.editedIndex], guest)
        }
        this.showDialog = false
      },

      showDetailDialog (index) {
        // Hack na click.capture na v-card (nejprve probehne click na v-card a potom teprve na ostatnich elementech).
        setTimeout(() => {
          if (this.otherMouseClick) {
            this.otherMouseClick = false
            return
          }
          this.editedGuest = this.guests[index]
          this.showGuestDetailDialog = true
        }, 100)
      },
      closeDetailDialog () {
        this.showGuestDetailDialog = false
      },

      confirmVote (guest, action) {
        this.otherMouseClick = true

        this.$swal({
          title: this.$t('vote'),
          text: this.$t('vote_question'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('no')
        }).then(result => {
          if (result.value) {
            this.doVote(guest, action)
          }
        })
      },

      doVote (guest, action) {
        utils.HTTP.post('guest/' + guest.id + '/vote', { action })
          .then(result => {
            if (result.data.status < 0) {
              /*
              this.$notify({
                group: 'app',
                type: 'error',
                text: '<center>' + result.data.message + '</center>',
                duration: 2000
              })
              */
              this.$swal(
                this.$t('error'),
                result.data.message,
                'error'
              )
            } else {
              guest.positive = result.data.positive
              guest.negative = result.data.negative
            }
          })
          .catch(error => {
            console.log('Error: ' + error.message)
            this.$notify({
              group: 'app',
              type: 'error',
              text: '<center>' + error.message + '</center>',
              duration: 1000
            })
          })
      },

      getHotelUrl (guest) {
        return utils.getHrefUrl(guest.hotel_url)
      },

      getCountryFlagUrl (iso) {
        return utils.getCountryFlagUrl(iso)
      }
    }
}
</script>

<style scoped>
.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/components/Guests/GuestsList.vue